import routes from './module/routes';
import store from './module/store';

export default {
  name: 'linkHandler',
  routes,
  store,
  requires: ['api', 'auth']
};
